<script lang="ts">
  import type { schema } from "@editor/schema";
  import { getNewsletterStores } from "../../../newsletterStores";
  import { isEmpty as isEmptyTest } from "../../blocksConfig";
  import { getBlockId, isEditor, trackingAndAttributesFromCTA } from "../../utils";
  import { Base64PlaySVGImageData } from "./utils";

  export let block: schema.VideoBlock;

  $: isEmpty = isEmptyTest(block);

  function getTimestampParameter() {
    let hasTimestamp = block.url?.match(/t=[0-9]+/g);
    return hasTimestamp ? `&start=${hasTimestamp[0].split("=")[1]}` : "";
  }

  const cta = block.movie
    ? {
        url: `https://www.youtube.com/embed/${block.movie}?autoplay=1&rel=0&showinfo=0${getTimestampParameter()}`,
        id: `v-${block._id}`
      }
    : undefined;

  const { ctx } = getNewsletterStores();
  const blockId = getBlockId();
  const [target, hrefAttrs] = trackingAndAttributesFromCTA(ctx, cta, { type: "video", text: block.title, blockId });
</script>

<div class="content no-screenshot widget-video-youtube-new">
  <div class="framed-image-container no-drag" class:p-2={isEmpty}>
    <div class="relative video-box">
      {#if isEmpty}
        <div class="absolute inset-0 flex items-center justify-center text-gray-600 bg-gray-100 border-2 border-dashed rounded-lg">
          Youtube video
        </div>
      {:else}
        <button
          class="relative flex items-center justify-center w-full h-full bg-center bg-no-repeat bg-cover iframeMe"
          data-video-url={target}
          data-video-title={block.title}
          data-video-original-url={cta?.url}
          style="background-image: url('https://img.youtube.com/vi/{block.movie}/hqdefault.jpg')">
          <span
            class="absolute top-0 left-0 right-0 px-2 py-1 text-left text-white truncate text-16"
            style="background:linear-gradient(#000000A0, #00000050);">
            {block.title}
          </span>
          <img
            src={Base64PlaySVGImageData}
            width="700"
            alt="Click to play: {block.title}"
            style="display:block !important; max-width:700px;width:100%;height:240px;" />
        </button>
      {/if}
    </div>
  </div>
</div>

{#if !isEditor()}
  <div class="content only-screenshot widget-video-youtube-new">
    <div class="framed-image-container">
      <div class="video-box">
        <div
          class="video-thumbnail"
          style={`background: url("https://img.youtube.com/vi/${block.movie}/hqdefault.jpg") center / cover no-repeat`}>
          <div class="youtube-overlay" />
          {#if block.title}
            <div class="video-description">{block.title}</div>
          {/if}
        </div>
      </div>
    </div>
  </div>
{/if}

<style>
  .widget-video-youtube-new .framed-image-container {
    position: relative;
    height: 350px;
  }

  .widget-video-youtube-new iframe,
  .widget-video-youtube-new .video-box {
    height: auto;
    display: block;
    width: 100%;
    height: 100%;
  }

  .widget-video-youtube-new .video-shim {
    height: 100%;
    width: 100%;
    z-index: 1000;
    background: red;
    opacity: 0;
    display: block;
    position: absolute;
  }

  .widget-video-youtube-new.only-screenshot .video-box {
    overflow: hidden;
    background: black;
  }
  .widget-video-youtube-new.only-screenshot img {
    width: 100%;
  }
  .widget-video-youtube-new.only-screenshot .video-thumbnail {
    position: relative;
    width: 100%;
    height: 100%;
    background-size: contain;
  }
  .widget-video-youtube-new.only-screenshot .video-description {
    width: 100%;
    height: 33px;
    color: white;
    background-color: rgba(0, 0, 0, 0.6);
    font-family: Verdana, arial, sans-serif;
    font-size: 16px;
    padding: 10px 0 0 12px;
  }

  .widget-video-youtube-new.only-screenshot .youtube-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    background: url(/images/emails/youtube_overlay.png) no-repeat center center;
    top: 0;
    left: 0;
  }
</style>
